import { clientApi } from '../../configuration';
import getCRUDHooks from '../../utils/services/getCRUDHooks';

type MentorSuggestionsType = {
  userId: number;
  filters?: { startDate: string; endDate: string };
};

const { useGet: useMentoringDatesEligibility } = getCRUDHooks({
  entityName: 'mentoringEligibility',
  get: ({ userId, filters }: MentorSuggestionsType) =>
    clientApi.getOCClient().helpers.user.users.id(userId).mentoringDatesEligibility.find(filters),
});

// eslint-disable-next-line import/prefer-default-export
export { useMentoringDatesEligibility };
